import queryString from 'qs';

const getRoleRequest = (filter) => {
  const queries = { limit: 10, page: filter?.page };

  if (filter?.search) queries['search'] = filter?.search;
  if (filter?.sort) queries['sort'] = `${filter?.sort?.field}.${filter?.sort?.order}`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getRoleRequest;
